import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		maxWidth: 720,
	},
	timeTrigger: {
		maxWidth: 200,
	},
	// Wider than timeTrigger: "Morning of the meeting day" truncates under the 200px used for hour labels.
	deliveryTrigger: {
		maxWidth: 280,
	},
	statusLine: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'flex-start',
	},
	// The link variant keeps the button's 16px side padding, which would indent the link past the
	// checkbox and field labels it now sits above.
	briefsLink: {
		paddingLeft: 0,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
});
